export default __webpack_public_path__ + "static/media/detail_big_9_2.0ecda6bd.jpg";